import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { appConfig } from './app/app.config';
import { AppModule } from './app/app.module';

// Each new prequal session should start with a fresh chat. Drop any
// chat-related localStorage entries (`cwl_*`) left over from a prior visit
// so the widget can't replay stale session/messages on mount.
try {
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i);
    if (key && key.startsWith('cwl_')) localStorage.removeItem(key);
  }
} catch {
  // localStorage unavailable (private mode, disabled, etc.) — nothing to clear.
}

platformBrowserDynamic([{ provide: 'appConfig', useValue: appConfig }])
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
